import {easepick} from '@easepick/bundle';
import {RangePlugin} from '@easepick/range-plugin';
import {LockPlugin} from '@easepick/lock-plugin';
import {AmpPlugin} from '@easepick/amp-plugin';
import {KbdPlugin} from '@easepick/kbd-plugin';

const today = new Date();
const datePickerContainerSelector = '.js-datepicker-container';

let datepicker;
let firstInit;
let resetDatepicker;
let selectDates;
let isDropdownOpen;

function initDatepicker() {
    if (typeof datepicker !== 'undefined' && typeof datepicker.destroy === 'function') {
        datepicker.destroy();
    }

    let datepickerDropdownBtn = $('.js-datepicker-input');
    let datepickerContainer = $(datePickerContainerSelector);
    let cssLink = datepickerContainer.data('css');
    let datepickerSelection = $('#datepicker-selection');
    let datepickerResetButton = $('.js-reset-datepicker');
    let datepickerBackBtnMobile = $('.js-back-arrow');

    let startDate = $('.js-datepicker-start-date').val();
    let endDate = $('.js-datepicker-end-date').val();

    const rangeCheckbox = $(".js-range-checkbox");
    const rangePreset = $(".js-range-preset");
    isDropdownOpen = false;
    let minDate = new Date().getTime();
    let maxDate = new Date().setDate(new Date().getDate()+365);

    let easepickEls = document.querySelectorAll('#easepick');

    if (easepickEls.length) {
        rangeCheckbox.off('change').on('change', function () {
            let checkedRange = $(this);
            let isChecked = checkedRange.prop('checked');
            let rangeValue = parseInt(checkedRange.val()) * 1000 * 60 * 60 * 24;

            let startDateStr = $('.js-datepicker-start-date').val();
            let endDateStr = $('.js-datepicker-end-date').val();

            if (!startDateStr || !endDateStr) {
                checkedRange.prop('checked', false);
                return;
            }

            let startDate = parseInt(startDateStr);
            let endDate = parseInt(endDateStr);
            let prevRangeID = window.localStorage.getItem('rangeValueID');

            if (isChecked) {
                if (prevRangeID && prevRangeID !== checkedRange.attr('id')) {
                    let $prevRange = $('#' + prevRangeID);
                    if ($prevRange.length) {
                        let prevRangeValue = parseInt($prevRange.val()) * 1000 * 60 * 60 * 24;
                        startDate += prevRangeValue;
                        endDate -= prevRangeValue;
                    }
                }

                startDate -= rangeValue;
                endDate += rangeValue;

                window.localStorage.setItem('rangeValueID', checkedRange.attr('id'));
                $(".js-range-checkbox").not(checkedRange).prop('checked', false);
            } else {
                if (prevRangeID === checkedRange.attr('id')) {
                    startDate += rangeValue;
                    endDate -= rangeValue;
                    window.localStorage.removeItem('rangeValueID');
                }
            }

            window.easepick.forEach(function (esPick) {
                esPick.setStartDate(startDate);
                esPick.setEndDate(endDate);
            });

            $('.js-datepicker-start-date').each(function () {
                $(this).val(startDate).trigger('change');
            });

            $('.js-datepicker-end-date').each(function () {
                $(this).val(endDate).trigger('change');
            });

            if ($('.js-datepicker-start-date').val() !== '' && $('.js-datepicker-end-date').val() !== '' && !firstInit && selectDates) {
                setDatepickerSelection(datepickerResetButton);
                selectDates = false;
            }

            if (!datepickerResetButton.hasClass('show')) {
                datepickerResetButton.addClass('show');
            }
        });
    }

    easepickEls.forEach((easepickEl) => {
        if (easepickEl) {
            let picker = new easepick.create({
                element: easepickEl,
                css: [cssLink],
                lang: 'it-IT',
                format: 'YYYY-MM-DDTHH:mm:ss.sssZ',
                zIndex: 20,
                inline: true,
                calendars: Math.min(window.innerWidth, window.screen.width) > 1024 ? 1 : 2,
                grid: Math.min(window.innerWidth, window.screen.width) > 1024 ? 1 : 2,
                setup(picker) {
                    picker.on('render', () => {
                        const ui = picker.ui;

                        if (!ui || !ui.shadowRoot) return;

                        const shadowRoot = ui.shadowRoot;
                        const container = shadowRoot.querySelector('.container');

                        if (container) {
                            $(container).addClass('datepicker').addClass('datepicker-search-results');

                            if (easepickEl.closest('#home-extended-search-form')) {
                                $(container).addClass('p-0');
                            }

                            if (!container.dataset.customClickBound) {
                                container.addEventListener('click', (e) => {
                                    const dayEl = e.target.closest('.day');

                                    if (dayEl && !dayEl.classList.contains('locked')) {
                                        let currentStart = picker.getStartDate();
                                        let currentEnd = picker.getEndDate();

                                        if (currentStart && currentEnd) {
                                            picker.clear();

                                            $(".js-range-checkbox").prop('checked', false);
                                            window.localStorage.removeItem('rangeValueID');
                                        }
                                    }
                                }, true);

                                container.dataset.customClickBound = 'true';
                            }

                            container.querySelectorAll('.day').forEach((dayEl) => {
                                var ts = parseInt(dayEl.dataset.time, 10);
                                if (!isNaN(ts)) {
                                    dayEl.setAttribute('role', 'button');
                                    dayEl.setAttribute('aria-label', new Date(ts).toLocaleDateString('it-IT', {
                                        weekday: 'long',
                                        day: 'numeric',
                                        month: 'long',
                                        year: 'numeric'
                                    }));
                                }
                                var unavailable = dayEl.classList.contains('locked')
                                    || dayEl.classList.contains('not-available');
                                dayEl.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
                                var selected = dayEl.classList.contains('start')
                                    || dayEl.classList.contains('end')
                                    || dayEl.classList.contains('selected');
                                dayEl.setAttribute('aria-pressed', selected ? 'true' : 'false');
                            });
                        }
                    });
                },
                plugins: [RangePlugin, LockPlugin, AmpPlugin, KbdPlugin],
                RangePlugin: {
                    tooltip: false,
                    startDate: !selectDates ? null : startDate,
                    endDate: !selectDates ? null : endDate
                },
                LockPlugin: {
                    minDate: minDate,
                    maxDate: maxDate
                },
                AmpPlugin: {
                    darkMode: false
                },
                KbdPlugin: {
                    unitIndex: 0,
                    dayIndex: -1,
                    html: '<span></span>'
                }
            });

            if (!Array.isArray(window.easepick)) {
                window.easepick = [];
            }

            window.easepick.push(picker);

            if (picker.ui && picker.ui.container && !picker.ui.container.dataset.gridBridgeBound) {
                picker.ui.container.dataset.gridBridgeBound = 'true';
                picker.ui.container.addEventListener('keydown', function (e) {
                    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') {
                        return;
                    }
                    var t = e.target;
                    var onMonthButton = t && t.classList
                        && (t.classList.contains('previous-button') || t.classList.contains('next-button'));
                    if (!onMonthButton) {
                        return;
                    }
                    var container = picker.ui.container;
                    var target = container.querySelector('.day.start, .day.end, .day.selected')
                        || container.querySelector('.day.today')
                        || container.querySelector('.day.unit:not(.locked):not(.not-available)');
                    if (target) {
                        e.preventDefault();
                        e.stopPropagation();
                        target.focus();
                    }
                }, true);
            }

            if (firstInit && !selectDates || resetDatepicker) {
                picker.clear();
            }

            picker.on('select', e => {
                let startDate = e.detail.start.format('YYYY-MM-DDTHH:mm:ss.sssZ');
                let endDate = e.detail.end.format('YYYY-MM-DDTHH:mm:ss.sssZ');
                let startDateTimestamp = new Date(startDate).getTime();
                let endDateTimestamp = new Date(endDate).getTime();
                selectDates = true;

                // Uncheck the variation checkboxes when the selection is complete
                $(".js-range-checkbox").prop('checked', false);
                window.localStorage.removeItem('rangeValueID');

                $('.js-datepicker-start-date').each(function () {
                    $(this).val(startDateTimestamp).trigger('change');
                });

                $('.js-datepicker-end-date').each(function () {
                    $(this).val(endDateTimestamp).trigger('change');
                });

                setDatepickerSelection(datepickerResetButton);

                setTimeout(function () {
                    if (document.activeElement && document.activeElement !== document.body) {
                        return;
                    }
                    var container = picker.ui && picker.ui.container;
                    if (!container) {
                        return;
                    }
                    var endDay = container.querySelector('.day.end')
                        || container.querySelector('.day.selected');
                    if (endDay) {
                        endDay.focus();
                    }
                }, 0);
            });

            datepickerDropdownBtn.on('click', (event) => {
                event.stopPropagation();
                if (!isDropdownOpen) {
                    datepickerDropdownShow(picker, datepickerContainer, datepickerResetButton);

                    $('.js-datepicker-apply').click(function() {
                        datepickerDropdownHide(picker, datepickerContainer, datepickerDropdownBtn, datepickerSelection);
                    });
                    $(window).off('click.datepicker.close');
                    $(window).on('click.datepicker.close', (event) => {
                        var targetElement = $(event.target);

                        if (targetElement.closest(datePickerContainerSelector).length === 0) {
                            datepickerDropdownHide(picker, datepickerContainer, datepickerDropdownBtn, datepickerSelection);
                        }
                    });

                    $(document).off('keydown.datepicker.close');
                    $(document).on('keydown.datepicker.close', (event) => {
                        if (event.key === 'Escape' && isDropdownOpen) {
                            datepickerDropdownHide(picker, datepickerContainer, datepickerDropdownBtn, datepickerSelection);
                            datepickerDropdownBtn.focus();
                        }
                    });
                }
            });

            datepickerBackBtnMobile.on('click', () => {
                datepickerDropdownHide(picker, datepickerContainer, datepickerDropdownBtn, datepickerSelection);
            });

            datepickerResetButton.on('click', () => {
                datepickerReset(picker, datepickerSelection, datepickerDropdownBtn, rangePreset, datepickerResetButton);
            });

            rangePreset.on('click', (event) => {
                rangePreset.removeClass('selected');
                $(event.target).addClass('selected');
                let rangeValue = $(event.target).data('value');

                if (!rangeValue) {
                    rangeValue = $(event.target).closest('.js-range-preset').data('value');
                }

                let startDate = rangeValue.start;
                let endDate = rangeValue.end;

                if (startDate && endDate) {
                    $(".js-range-checkbox").prop('checked', false);
                    window.localStorage.removeItem('rangeValueID');

                    picker.setStartDate(startDate);
                    picker.setEndDate(endDate);
                    picker.gotoDate(startDate);
                    
                    datepickerSetDates(startDate, endDate);
                    selectDates = true;
                    datepickerSelection.html("Dal <strong>" + formatDate(new Date(parseInt(startDate))) + "</strong> Al <strong>" + formatDate(new Date(parseInt(endDate))) + "</strong>");

                    let homeExtendedSearchForm = $(event.target).closest('#home-extended-search-form');
                    if (homeExtendedSearchForm && homeExtendedSearchForm.length > 0) {
                        $('.js-datepicker-start-date').each(function () {
                            $(this).val(startDate).trigger('change');
                        });

                        $('.js-datepicker-end-date').each(function () {
                            $(this).val(endDate).trigger('change');
                        });
                    }

                    if (startDate === 'null' && endDate === 'null') {
                        datepickerReset(picker, datepickerSelection, datepickerDropdownBtn, rangePreset, datepickerResetButton);
                    }
                } else {
                    datepickerReset(picker, datepickerSelection, datepickerDropdownBtn, rangePreset, datepickerResetButton);
                }
            });

            let rangeValueID = window.localStorage.getItem('rangeValueID');
            $('#' + rangeValueID).prop('checked', true).trigger('change');
        }
    });
}

$(document).on('keydown', '.anytime-container.js-range-preset', function (e) {
    if (e.which === 13 || e.which === 32) {
        e.preventDefault();
        $(this).trigger('click');
    }
});

$(document).on('keydown', '.datepicker-range-variations .js-range-checkbox', function (e) {
    if (e.which === 13) {
        e.preventDefault();
        this.checked = !this.checked;
        $(this).trigger('change');
    }
});

$(document).ready(() => {
    window.localStorage.removeItem('rangeValueID');
    if ($('#easepick').length) {
        firstInit = true;
        initDatepicker();
    }
});

$(document).on('search:applied', function () {
    firstInit = false;
    initDatepicker();
});

$(document).on('search:filter', function(e, eventData){
    let parentElements = $(eventData.target).parents();
    let resetDatepickerFilter = false;

    // looking for parent element as refinement datepicker cancel button
    parentElements.each((index,el) => {
        if($(el).attr('id') === 'refinement-data-partenza') {
            resetDatepickerFilter = true;
        }
    });

    resetDatepicker = !!($(eventData.target).hasClass('reset') || resetDatepickerFilter);
});

function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
}

function formatDate(date) {
    return [
        padTo2Digits(date.getDate()),
        padTo2Digits(date.getMonth() + 1),
        date.getFullYear(),
    ].join('/');
}

function setDatepickerSelection(datepickerResetButton) {
    let datepickerSelections = document.querySelectorAll('#datepicker-selection');

    if (!resetDatepicker) {
        datepickerResetButton.addClass('show');
        let startDate = parseInt($('.js-datepicker-start-date').val());
        let endDate = parseInt($('.js-datepicker-end-date').val());

        let dS = formatDate(new Date(startDate));
        let dE = formatDate(new Date(endDate));

        datepickerSelections.forEach((datepickerSelection) => {
            datepickerSelection.innerHTML = "Dal <strong>" + dS + "</strong> Al <strong>" + dE + "</strong>";
        });
    } else {
        datepickerSelections.forEach((datepickerSelection) => {
            datepickerSelection.innerHTML = "";
        });
    }

}

function datepickerDropdownShow(picker, datepickerDropdownContainer, datepickerResetButton) {
    if (!selectDates) {
        let datepickerSelections = document.querySelectorAll('#datepicker-selection');
        datepickerSelections.forEach((datepickerSelection) => {
            datepickerSelection.innerHTML = "";
        });
    }

    datepickerDropdownContainer.addClass('show');
    picker.show();
    isDropdownOpen = true;

    if ($('.js-datepicker-start-date').val() !== '' && $('.js-datepicker-end-date').val() !== '' && !firstInit && selectDates) {
        setDatepickerSelection(datepickerResetButton);
        selectDates = false;
    }
}

function datepickerDropdownHide(picker, datepickerDropdownContainer, datepickerDropdownBtn, datepickerSelection) {
    datepickerDropdownBtn.html(datepickerSelection.html() !== '' ? datepickerSelection.html() : 'Periodo partenza');
    datepickerDropdownContainer.removeClass('show');
    picker.hide();
    $(window).off('click.datepicker.close');
    isDropdownOpen = false;

    //Do the search
    if (selectDates) {
        doSearch(datepickerDropdownContainer);
    }
}

function doSearch(datepickerContainer) {
    var startDate = $('.js-datepicker-start-date').val();
    var endDate = $('.js-datepicker-end-date').val();
    var href = datepickerContainer.data('refine').replace('datamin', startDate).replace('datamax', endDate);

    $(document).trigger('applyfilter', {
        href: href
    })
}

function datepickerReset(picker, datepickerSelection, datepickerDropdownBtn, rangePresets, datepickerResetButton) {
    picker.clear();
    picker.gotoDate(today);
    datepickerResetDates();
    rangePresets.removeClass('selected');
    rangePresets.last().addClass('selected');
    datepickerDropdownBtn.html('Periodo partenza');
    datepickerSelection.html('');
    $(".js-range-checkbox").prop('checked', false);
    datepickerResetButton.removeClass('show');
    var $removeDatePick = $("#refinement-data-partenza .js-remove-refinement");

    if ($removeDatePick.length)
        $removeDatePick.click();
}

function datepickerSetDates(startDate, endDate) {
    $(".js-datepicker-start-date").val(startDate);
    $(".js-datepicker-end-date").val(endDate);
}

function datepickerResetDates() {
    $(".js-datepicker-start-date").val('').trigger('change');
    $(".js-datepicker-end-date").val('').trigger('change');
}
